export class ProductCatalogueProduct {
    productId: string;
    name: string;
    description?: string;
}